import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Org default currency (#2246). Small org-wide value shared across the matter
 * create form, billing-rate panel and Organization Settings — cached here so the
 * consumers don't each refetch. `value` is the lowercase ISO 4217 code from the
 * BE (or null); `loaded` flips true after the first fetch resolves (success or not).
 */
interface OrgDefaultCurrencyState {
  value: string | null;
  loaded: boolean;
}

const initialState: OrgDefaultCurrencyState = { value: null, loaded: false };

const orgDefaultCurrencySlice = createSlice({
  name: 'orgDefaultCurrency',
  initialState,
  reducers: {
    setOrgDefaultCurrency(state, action: PayloadAction<string | null>) {
      state.value = action.payload;
      state.loaded = true;
    },
  },
});

export const { setOrgDefaultCurrency } = orgDefaultCurrencySlice.actions;
export default orgDefaultCurrencySlice.reducer;
